import React, { useState, useEffect } from "react";
import { useAuth } from "../../../Context/AuthContext";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Divider,
  FormHelperText,
  ListItemText,
  Checkbox,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClientNavtabs from "./ClientNavtabs";
import { DataGrid } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
const NewClientInteraction = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const leadId = location.state?.leadId;
  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("userId");
  // const token = sessionStorage.getItem("token");
  const apiUrl = process.env.REACT_APP_API_REST_URL;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  // Handle menu navigation
  const handleMenuClick = (action) => {
    switch (action) {
      case "profile":
        navigate("/employeedashboard/clients/edit", { state: { leadId } });
        break;
      case "interactions":
        navigate("/employeedashboard/clients/interactions", {
          state: { leadId },
        });
        break;
      case "add-interaction":
        break;
      case "kyc":
        navigate("/employeedashboard/clients/kyc", {
          state: { leadId },
        });
        break;
      case "documents":
        // Navigate to documents
        break;
      case "add-business-numbers":
        navigate("/employeedashboard/clients/add-business-numbers", {
          state: { leadId },
        });
        break;
      case "business-numbers":
        navigate("/employeedashboard/clients/business-numbers", {
          state: { leadId },
        });
        break;
      default:
        break;
    }
  };
  const [leadData, setLeadData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchLeadData = async () => {
      if (!leadId) {
        setIsLoading(false);
        setError("No lead ID provided");
        return;
      }

      try {
        setIsLoading(true);
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/referalEngine/getReferralById/${leadId}`
        );
        setLeadData(response.data);
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to load lead data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeadData();
  }, [leadId, apiUrl]);
  const interactions = leadData?.interactionDetails || [];
  const parsedOtherBusiness = (data) => {
    if (!data) return [];
    const ids = data.split(",").map((id) => parseInt(id.trim())); // Parse each id as integer
    return ids.map((id) => {
      const product = otherBusinessTypes.find((item) => item.id === id);
      return product ? product.masterValueDesc : id;
    });
  };
  const parseWealthProducts = (data) => {
    if (!data) return [];
    const ids = data.split(",").map((id) => parseInt(id.trim())); // Parse each id as integer
    return ids.map((id) => {
      const product = wealthproductTypes.find((item) => item.id === id);
      return product ? product.masterValueDesc : id;
    });
  };
  const [rmOptions, setRmOptions] = useState([]);
  const [managerIdNameMap, setManagerIdNameMap] = useState({});
  const [isReferralRowData, setIsReferralRowData] = useState();
  const [charCount, setCharCount] = useState(0);
  const [discussionBrief, setDiscussionBrief] = useState("");
  const [discussionBriefError, setDiscussionBriefError] = useState("");
  const [engagementTypeError, setEngagementTypeError] = useState("");
  const [locationdesc, setlocationdesc] = useState("");
  const [reqdesc, setreqdesc] = useState(
    interactions?.client_requirement || ""
  );
  const [duration, setDuration] = useState("");
  const [reqotheradvisor, setreqotheradvisor] = useState("");
  const [reqothercount, setreqothercount] = useState(0);
  const [locationcharCount, setLocationCharCount] = useState(0);
  const [reqcharCount, setreqcharCount] = useState(0);
  const [portfoliodesc, setPortfoliodesc] = useState("");
  const [portfolioCount, setportfolioCount] = useState(0);
  const [followupdesc, setFollowupdesc] = useState("");
  const [followupcharcount, setfollowupcharcount] = useState(0);
  const [additionalcomment, setadditionalcomment] = useState("");
  const [additionalcommentcharcount, setadditionalcommentcharcount] =
    useState(0);
  const [engagementTypes, setEngagementTypes] = useState([]);
  const [selectedEngagementType, setSelectedEngagementType] = useState("");
  const [locationTypes, setlocationTypes] = useState([]);
  const [selectedLocationTypes, setSelectedLocationTypes] = useState("");
  const [meetingDate, setMeetingDate] = useState(dayjs());
  const [expectedDateClosure, setExpectedDateClosure] = useState(null);
  const [meetingDuration, setMeetingDuration] = useState("");
  const [wealthproductTypes, setwealthproductTypes] = useState([]);

  const [otherBusinessTypes, setotherBusinessTypes] = useState([]);
  const [selectedotherbusinesstype, setSelectedotherbusinesstype] = useState(
    []
  );
  const [statustypes, setStatustypes] = useState([]);
  const [selectedStatustype, setselectedStatustype] = useState("");
  const [leadstatustypes, setleadstatustypes] = useState([]);
  const [selectedleadstatustype, setselectedleadstatustype] = useState("");
  const [annualincometypes, setannualincometypes] = useState([]);
  const [selectedannualincometypes, setselectedannualincometypes] =
    useState("");
  const [selectedPortfolioRange, setSelectedPortfolioRange] = useState("");
  const [followuptypes, setfollowuptypes] = useState([]);
  const [selectedfollowuptype, setSelectedfollowuptype] = useState("");
  const [followuplocationtypes, setfollowuplocationtype] = useState([]);
  const [selectedfollowuplocationtype, setselectedfollowuplocationtype] =
    useState("");
  const [meetingDateTime, setMeetingDateTime] = useState(dayjs());
  const [meetingdurationtypes, setmeetingdurationtypes] = useState([]);
  const [selectedmeetingduration, setselectedmeetingduration] = useState("");
  const [selectedwealthproduct, setselectedwealthproduct] = useState([]);
  const [actualPortfolioValue, setActualPortfolioValue] = useState("");
  // const selectedWealthProductString = Array.isArray(selectedwealthproduct) ? selectedwealthproduct.join(',') : '';
  // const selectedotherbusinessstring = Array.isArray(selectedotherbusinesstype) ? selectedotherbusinesstype.join(',') : '';

  // State to hold the reason entered
  // State to control modal open/close
  console.log("roleid", roleId);
  // console.log("roleid id", selectedId);

  const statusValue = [
    { ids: 1, name: "Lead", value: "lead" },
    { ids: 2, name: "Client", value: "client" },
  ];

  // useEffect(() => {
  //   const isEmpty = Object.keys(interactions ?? {}).length === 0;
  //   if (!isEmpty) {
  //     setreqdesc(interactions?.client_requirement || "");
  //     setreqotheradvisor(interactions?.other_advisor || "");
  //     setselectedwealthproduct(
  //       parseWealthProducts(interactions?.wealth_product_discussed)
  //     );
  //     setSelectedotherbusinesstype(
  //       parsedOtherBusiness(interactions?.other_business_opportunity)
  //     );

  //     setselectedannualincometypes(interactions?.estimated_annual_income || "");
  //   }
  // }, [interactions]);

  const years = ["2024", "2023", "2022", "2021", "2020"];
  // const [valuee, setValuee] = React.useState<Dayjs | null>(dayjs('2022-04-17'));

  console.log(+interactions?.wealth_product_discussed, "isData");

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  // const transformSelectedValues = (values) => {
  //   return Array.isArray(values) && values.length > 0 ? values.join(",") : "";
  // };

  const formatDate = (date) => {
    return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
  };
  const wealthProductMap = {};
  wealthproductTypes.forEach((item) => {
    wealthProductMap[item.masterValueDesc] = item.id;
  });
  const otherBusinessMap = {};
  otherBusinessTypes.forEach((item) => {
    otherBusinessMap[item.masterValueDesc] = item.id;
  });
  // const transformSelectedValues = (selectedArray) => {
  //   return selectedArray.map(desc => wealthProductMap[desc]);
  // };
  const transformSelectedValues = (selectedArray) => {
    return selectedArray.map((desc) => wealthProductMap[desc]).join(",");
  };
  const transformSelectedValuesother = (selectedArray) => {
    return selectedArray.map((desc) => otherBusinessMap[desc]).join(",");
  };
  useEffect(() => {
    if (interactions && interactions.length > 0) {
      const sortedInteractions = [...interactions].sort((a, b) => {
        return new Date(b.created_date) - new Date(a.created_date);
      });
      const latestInteraction = sortedInteractions[0];
      // Pre-fill the form fields
      // setDiscussionBrief(latestInteraction.discussion_brief || "");
      // setSelectedEngagementType(latestInteraction.engagement_type || "");
      if (latestInteraction.expected_date_of_closure) {
        setExpectedDateClosure(
          dayjs(latestInteraction.expected_date_of_closure)
        );
      }
      if (latestInteraction.followup_date_n_time) {
        setMeetingDateTime(dayjs(latestInteraction.followup_date_n_time));
      }

      // setselectedmeetingduration(latestInteraction.meeting_duration || "");
      setreqdesc(latestInteraction.client_requirement || "");
      setselectedannualincometypes(
        latestInteraction.estimated_annual_income || ""
      );
      setselectedwealthproduct(
        parseWealthProducts(latestInteraction.wealth_product_discussed || "")
      );
      setSelectedotherbusinesstype(
        parsedOtherBusiness(latestInteraction.other_business_opportunity || "")
      );

      setreqotheradvisor(latestInteraction.other_advisor || "");
      setselectedStatustype(latestInteraction.status || "");
      setselectedleadstatustype(latestInteraction.lead_status || "");
      setSelectedPortfolioRange(
        latestInteraction.estimated_portfolio_range || ""
      );
      setPortfoliodesc(latestInteraction.estimated_portfolio_value || "");
      setActualPortfolioValue(latestInteraction.actual_portfolio_value || "");
      setadditionalcomment(latestInteraction.comment || "");
      setSelectedfollowuptype(latestInteraction.followup_type || "");
    }
  }, [interactions]);
  const OnSubmitdata = async () => {
    console.log("selecterd status inside submit", selectedStatustype);

    const selectedWealthProductString = transformSelectedValues(
      selectedwealthproduct
    );
    const selectedotherbusinessstring = transformSelectedValuesother(
      selectedotherbusinesstype
    );
    // console.log("sdflref",selectedWealthProductString);
    const formattedMeetingDate = meetingDate ? formatDate(meetingDate) : null;
    const formattedMeetingDateTime = meetingDateTime
      ? formatDate(meetingDateTime)
      : null;
    const formattedExpectedDateClosure = expectedDateClosure
      ? formatDate(expectedDateClosure)
      : null;

    const headers = {
      "x-access-token": token,
    };

    // if (selectedWealthProductString) {
    try {
      // -----------------
      if (selectedStatustype === 23) {
        // Update referral status
        try {
          await axios.put(
            `${apiUrl}/CCE/api/v1/referalEngine/updateStatus`,
            {
              clientId: leadData.id,
              status: "lead",
            },
            { headers }
          );
        } catch (error) {
          console.error("Error updating referral status", error);
          return; // Exit if the status update API call fails
        }
      } else if (selectedStatustype === 24) {
        // Update lead status
        try {
          await axios.put(
            `${apiUrl}/CCE/api/v1/referalEngine/updateStatus`,
            {
              clientId: leadData.id,
              status: "client",
            },
            { headers }
          );
        } catch (error) {
          console.error("Error updating lead status", error);
          return; // Exit if the status update API call fails
        }
      } else if (selectedStatustype === 25) {
        // Update to dropped status
        try {
          await axios.put(
            `${apiUrl}/CCE/api/v1/referalEngine/updateStatus`,
            {
              clientId: leadData.id,
              status: "clientDrop",
            },
            { headers }
          );
        } catch (error) {
          console.error("Error updating status to leadDrop", error);
          return; // Exit if the status update API call fails
        }
      }
      // -------------
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/referralInteraction`,
        {
          clientId: leadData.id,
          discussion_brief: discussionBrief,
          engagement_type: selectedEngagementType,
          meeting_at: formattedMeetingDate,
          meeting_duration: selectedmeetingduration,
          location_type: selectedLocationTypes,
          location: locationdesc,
          client_requirement: reqdesc,
          other_advisor: reqotheradvisor,
          status: selectedStatustype,
          lead_status: selectedleadstatustype,
          expected_date_of_closure: formattedExpectedDateClosure,
          estimated_annual_income: selectedannualincometypes,
          estimated_portfolio_range: selectedPortfolioRange,
          actual_portfolio_value: actualPortfolioValue,
          estimated_portfolio_value: portfoliodesc,
          followup_type: selectedfollowuptype,
          followup_date_n_time: formattedMeetingDateTime,
          followup_location_type: selectedfollowuplocationtype,
          followup_location: followupdesc,
          comment: additionalcomment,
          wealth_product_discussed: selectedWealthProductString,
          other_business_opportunity: selectedotherbusinessstring,
        },
        { headers }
      );

      console.log("response edit", response.data);
      if (response?.data?.statusMessage === "Success") {
        // toast.success("Interaction Details added successfully.");
        // onStatusUpdate("success");
        // } else {
        //   toast.error("Update failed");
        //   // onStatusUpdate("failure");
        // }

        console.log("resva", response);
        setDiscussionBrief("");
        setSelectedEngagementType("");
        setMeetingDate(null);
        setMeetingDuration("");
        setSelectedLocationTypes("");
        setlocationdesc("");
        setreqdesc("");
        setreqotheradvisor("");
        setselectedwealthproduct([]);
        setSelectedotherbusinesstype([]);
        setselectedStatustype("");
        setselectedleadstatustype("");
        setExpectedDateClosure(null);
        setselectedmeetingduration("");
        setselectedannualincometypes("");
        setSelectedPortfolioRange("");
        setActualPortfolioValue("");
        setPortfoliodesc("");
        setMeetingDateTime(null);
        setSelectedfollowuptype("");
        setselectedfollowuplocationtype("");
        setadditionalcomment("");
        if (selectedStatustype === 24 || selectedStatustype === 25) {
          toast.success("Interaction added successfully.");
          setTimeout(() => {
            navigate("/employeedashboard/clients");
          }, 600); // 2-second delay to show the success toast
        } else {
          setTimeout(() => {
            toast.success("Interaction added successfully.");
            navigate("/employeedashboard/clients/interactions", {
              state: { leadId },
            });
          }, 600);
        }
      } else {
        toast.error("Update failed");
      }

      console.log("resva", response);
      console.log("seree", selectedWealthProductString);
    } catch (error) {
      console.error("Error submitting data", error);
      toast.error("An error occurred while submitting data");
    }
  };

  // console.log("clientList:", clientList[0]?.created_date);

  const handleReasonChange = (event) => {
    const value = event.target.value;
    setDiscussionBrief(value);
    setDiscussionBriefError(value ? "" : "Please enter discussion brief");
  };
  const handleLocationdescChange = (event) => {
    const input = event.target.value;
    setlocationdesc(input);
    setLocationCharCount(input.length);
  };
  const handleRequirementChange = (event) => {
    const input = event.target.value;
    setreqdesc(input);
    setreqcharCount(input.length);
  };
  const handleRequirementChangeother = (event) => {
    const input = event.target.value;
    setreqotheradvisor(input);
    setreqothercount(input.length);
  };
  const handlePortfolioChange = (event) => {
    const input = event.target.value;
    setPortfoliodesc(input);
    setportfolioCount(input.length);
  };
  const handleActualPortfolioChange = (event) => {
    const input = event.target.value;
    let numericValue = input.replace(/,/g, "");
    if (numericValue === "") {
      setActualPortfolioValue("");
      return;
    }
    if (!/^\d*$/.test(numericValue)) {
      return;
    }
    if (parseInt(numericValue, 10) > 1000000000) {
      return;
    }
    const formattedValue = parseInt(numericValue, 10).toLocaleString("en-IN");
    setActualPortfolioValue(formattedValue);
  };
  const handlefollowChange = (event) => {
    const input = event.target.value;
    setFollowupdesc(input);
    setfollowupcharcount(input.length);
  };
  const handleadditionalcommentChange = (event) => {
    const input = event.target.value;
    setadditionalcomment(input);
    setadditionalcommentcharcount(input.length);
  };

  const getEngagementtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/engagement_type`;
      const response = await axios.get(url, {});
      // console.log("engagementdata", response);
      setEngagementTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLocationtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/location_type`;
      const response = await axios.get(url, {});
      console.log("locationdata", response);

      const updatedLocationTypes = response.data.response.map((item) => {
        if (item.masterValueDesc === "Client Office") {
          return { ...item, masterValueDesc: "Lead's Office" };
        }
        return item;
      });

      setlocationTypes(updatedLocationTypes);
    } catch (e) {
      console.log(e);
    }
  };

  const getWealthproducttypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/Wealth_product_discussed`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setwealthproductTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  console.log("waelthndata", wealthproductTypes);
  const getOtherBusinesstypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/other_business_opportunity`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setotherBusinessTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
    console.log("waelthndata", wealthproductTypes);
  };
  const getstatustypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/status`;
      const response = await axios.get(url, {});
      console.log("statussssss", response);
      setStatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLeadstatusData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/lead_status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setleadstatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getfollowupData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/follow_up_type`;
      const response = await axios.get(url, {});
      console.log("followuprypes data", response);
      setfollowuptypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getfollowlocationData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/followup_location_type`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setfollowuplocationtype(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getmeetingdurationData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/meeting_duration`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setmeetingdurationtypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  // console.log("wealth product",se)

  useEffect(() => {
    getEngagementtypeData();
    getLocationtypeData();
    getWealthproducttypeData();
    getOtherBusinesstypeData();
    getstatustypeData();
    getLeadstatusData();
    getAnnualincomeData();
    getfollowupData();
    getfollowlocationData();
    getmeetingdurationData();
  }, []);

  // useEffect(() => {
  //   if (isChangeStatusModalOpen ){
  //     setMeetingDate(dayjs());
  //     // setSelectedStartTime(calculateNextTimeSlot())
  //     // setSelectedEndTime(calculateNextEndTime(selectedStartTime))
  //   }
  // },[isChangeStatusModalOpen]);

  useEffect(() => {
    if (leadData && leadData.id) {
      console.log("existing data", leadData);
      setIsReferralRowData(leadData);

      setValue("clientId", leadData.id);
      setValue("referralName", `${leadData.firstname} ${leadData.lastname}`);
      setValue("managerName", leadData.managerName);
      setValue("status", leadData.status);
      setValue("description", leadData.description);
    }
  }, [leadData, setValue]);

  console.log(isReferralRowData);
  // console.log(selectedId);
  // console.log(clientList);

  console.log("rmOptionsNew", rmOptions);

  // handlechange
  const handleengagementChange = (event) => {
    const value = event.target.value;
    setSelectedEngagementType(value);
    setEngagementTypeError(value ? "" : "Please select engagement type");
  };
  const handleLocationChange = (event) => {
    setSelectedLocationTypes(event.target.value);
  };

  const handleStatusChange = (event) => {
    setselectedStatustype(event.target.value);
  };

  const handlemeetingdurationChange = (event) => {
    setselectedmeetingduration(event.target.value);
  };

  const handleLeadStatusChange = (event) => {
    setselectedleadstatustype(event.target.value);
  };
  const handlefollowupChange = (event) => {
    setSelectedfollowuptype(event.target.value);
  };
  console.log("selected followuptype", selectedfollowuptype);
  const handlefollowuplocationChange = (event) => {
    setselectedfollowuplocationtype(event.target.value);
  };

  const handleAnnualIncomeChange = (event) => {
    setselectedannualincometypes(event.target.value);
  };
  const handlePortfolioRangeChange = (event) => {
    setSelectedPortfolioRange(event.target.value);
  };
  const handleDateChange = (newValue) => {
    setMeetingDate(newValue);
    console.log("new value date", newValue);
  };

  const handleDateTimeChange = (newValue) => {
    setMeetingDateTime(newValue);
    console.log("datetimevalue", meetingDateTime);
  };

  const handleDurationChange = (event) => {
    const { value } = event.target;
    const isValid =
      /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value) ||
      value === "" ||
      /^[0-9:]*$/.test(value);

    if (isValid) {
      setMeetingDuration(value);
    }
  };

  const handleexpectedDateChange = (newValue) => {
    setExpectedDateClosure(newValue);
    console.log("new dateee value", newValue);
  };
  const cancelHandler = () => {
    navigate("/employeedashboard/clients/view", { state: { leadId } });
  };

  return (
    <Box sx={styles.main_container}>
      {/* <ToastContainer
        position="bottom-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        toastStyle={{ textAlign: "left" }}
        theme="colored"
      /> */}

      <Paper sx={styles.dashboard_paper}>
        <ClientNavtabs
          handleMenuClick={handleMenuClick}
          options={[
            {
              label: "Edit Profile",
              onClick: () => handleMenuClick("profile"),
            },
            {
              label: "View Interactions",
              onClick: () => handleMenuClick("interactions"),
            },
            {
              label: "Add Interaction",
              onClick: () => handleMenuClick("add-interaction"),
            },
            { label: "View KYC", onClick: () => handleMenuClick("kyc") },
            {
              label: "Upload Documents",
              onClick: () => handleMenuClick("documents"),
              disabled: true,
            },
            {
              label: "Add Business Numbers",
              onClick: () => handleMenuClick("add-business-numbers"),
            },
            {
              label: "View Business Numbers",
              onClick: () => handleMenuClick("business-numbers"),
            },
          ]}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "25%",
            marginLeft: "auto",
          }}
        >
          <Button sx={styles.btn} variant="contained" onClick={cancelHandler}>
            Back
          </Button>
        </Box>
      </Paper>

      <Paper
        elevation={3}
        sx={{
          margin: "10px 20px 20px 20px",
          minHeight: "100px", // Ensures it doesn't collapse if empty
          borderRadius: "12px",
          padding: "20px", // Adds spacing inside the Paper
        }}
      >
        <div>
          <ToastContainer
            position="bottom-right"
            autoClose={7000}
            newestOnTop={true}
            closeOnClick
            pauseOnHover
            toastStyle={{ textAlign: "left" }}
            theme="colored"
          />

          {/* <Box sx={style}> */}
          {/* <form> */}
          <form onSubmit={handleSubmit(OnSubmitdata)}>
            <Box sx={{ textAlign: "center" }}>
              <Typography sx={{ fontSize: "22px" }}>
                <b>Interaction Form</b>
              </Typography>
              <Typography sx={{ margin: "10px 0px 12px 0px" }}>{`${
                isReferralRowData?.firstname
              } ${isReferralRowData?.lastname} | ${
                isReferralRowData?.email ?? "-"
              } | ${isReferralRowData?.phone}`}</Typography>
            </Box>
            <Paper sx={styles.papercss}>Discussion Details</Paper>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Box>
                <Box
                  sx={{
                    fontSize: "14px",
                    margin: "8px 0px -10px 0px",
                    textAlign: "left",
                  }}
                >
                  Discussion Brief<span style={{ color: "red" }}>*</span>
                </Box>
                <TextField
                  multiline
                  // label="Type here.."
                  variant="outlined"
                  value={discussionBrief}
                  rows={3}
                  onChange={handleReasonChange}
                  inputProps={{ maxLength: 150 }}
                  fullWidth
                  error={!!discussionBriefError}
                  helperText={
                    discussionBriefError ||
                    `${discussionBrief.length}/150 characters. Enter upto 150 characters. Please add what was discussed in the meeting in brief. Hobbies /likes /dislikes/assets /profile.`
                  }
                  sx={{
                    mt: 2,
                    width: "700px",
                    "& .MuiInputBase-inputMultiline": {
                      fontSize: "14px",
                    },
                    "& .MuiFormHelperText-root": {
                      textAlign: "left",
                      marginLeft: "-1px",
                    },
                  }}
                />
                {/* <FormHelperText sx={{fontSize:"12px"}}>Enter upto 1024 characters. Please add what was discussed in the meeting in brief. Hobbies /likes /dislikes/assets /profile</FormHelperText> */}
              </Box>
              <Box>
                <Box
                  sx={{
                    fontSize: "14px",
                    margin: "12px 0px -10px 0px",
                    textAlign: "left",
                  }}
                >
                  Engagement Type<span style={{ color: "red" }}>*</span>
                </Box>

                <FormControl
                  sx={{ width: "300px", height: "100px", pr: 1, mt: 2 }}
                  size="small"
                  error={!!engagementTypeError}
                >
                  {/* <InputLabel>Select Engagement Type</InputLabel> */}
                  <Select
                    sx={{
                      textAlign: "left",
                      fontSize: "14px",
                      "& .MuiSelect-multiple": {
                        fontSize: "14px",
                      },
                    }}
                    value={selectedEngagementType}
                    onChange={handleengagementChange}
                    //  input={<OutlinedInput label='Select Engagement Type' />}
                  >
                    {engagementTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.masterValueDesc}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText
                    sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                  >
                    Please select what was the mode of the call.
                  </FormHelperText>
                </FormControl>
              </Box>
            </Stack>
            <Paper sx={styles.papercss}>Meeting Time</Paper>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Box sx={{ width: "300px" }}>
                <Box
                  sx={{
                    fontSize: "14px",
                    margin: "8px 0px 4px 0px",
                    textAlign: "left",
                  }}
                >
                  Meeting Date & Time<span style={{ color: "red" }}>*</span>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    sx={{
                      paddingTop: "5px",
                    }}
                    components={["DateTimePicker"]}
                  >
                    <DateTimePicker
                      // label="Select Meeting Date & Time"
                      value={meetingDate}
                      onChange={handleDateChange}
                      format="DD/MM/YYYY hh:mm A" // Customize the format here
                      disableFuture
                      slotProps={{
                        // paddingTop: "5px",
                        textField: {
                          size: "small",
                        },
                      }}
                    />
                  </DemoContainer>
                  <FormHelperText sx={{ fontSize: "12px" }}>
                    Please select the date of the meeting and the start time of
                    the meeting.
                  </FormHelperText>
                </LocalizationProvider>
              </Box>

              {/* <Box sx={{width:"300px"}}>
<Box sx={{fontSize:"14px",margin:"8px 0px -3px 0px"}}>Meeting Duration</Box>
<TextField
  // label="Duration (HH:MM)"
  variant="outlined"
  value={meetingDuration}
  onChange={handleDurationChange}
  placeholder="00:00"
  fullWidth
  inputProps={{
    pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$', // Ensures the format HH:MM
    title: 'Enter time in HH:MM format'
  }}
  sx={{ mt: 2 }}
/>
      <FormHelperText sx={{fontSize:"12px"}}>Please add the duration of the meeting
</FormHelperText>




</Box> */}
              {/* <Box sx={{width: "300px"}}>
<Box sx={{fontSize: "14px", margin: "8px 0px -3px 0px"}}>Meeting Duration</Box>
<TextField
// label="Duration (HH:MM)"
variant="outlined"
value={meetingDuration}
onChange={handleDurationChange}
placeholder="00:00"
fullWidth
inputProps={{
inputMode: 'numeric', // Ensures only numeric input
type: 'text', // Use text type to ensure correct pattern matching
pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$', // Ensures the format HH:MM
title: 'Enter time in HH:MM format'
}}
sx={{ mt: 2 }}
/>
<FormHelperText sx={{fontSize: "12px"}}>Please add the duration of the meeting in HH:MM format.</FormHelperText>
</Box> */}
              {selectedEngagementType !== 1 && selectedEngagementType !== 5 && (
                <Box>
                  <Box
                    sx={{
                      fontSize: "14px",
                      margin: "12px 0px -10px 0px",
                      textAlign: "left",
                    }}
                  >
                    Meeting Duration
                  </Box>

                  <FormControl
                    sx={{ width: "300px", height: "100px", pr: 1, mt: 2 }}
                    size="small"
                  >
                    {/* <InputLabel>Select Engagement Type</InputLabel> */}
                    <Select
                      sx={{
                        textAlign: "left",
                        fontSize: "14px",
                        "& .MuiSelect-multiple": {
                          fontSize: "14px",
                        },
                      }}
                      value={selectedmeetingduration}
                      onChange={handlemeetingdurationChange}
                      //  input={<OutlinedInput label='Select Engagement Type' />}
                    >
                      {meetingdurationtypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.masterValueDesc}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                    >
                      Please add the duration of the meeting.
                    </FormHelperText>
                  </FormControl>
                  {selectedmeetingduration && (
                    <Tooltip title="Clear">
                      <IconButton
                        onClick={() => setselectedmeetingduration("")}
                        aria-label="clear selection"
                        size="small"
                        sx={{ ml: 1, mt: 2 }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              )}
            </Stack>
            {/* <Box></Box> */}
            {/* <Divider sx={{border:"1px solid gray",width:"105%",textAlign:"center",margin:"8px"}}/> */}
            {/* {selectedEngagementType === 4 && ( */}
              <Box>
                <Paper sx={styles.papercss}>Meeting Location</Paper>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                >
                  <Box>
                    <Box
                      sx={{
                        fontSize: "15px",
                        margin: "12px 0px -18px 0px",
                        textAlign: "left",
                      }}
                    >
                      Location Type<span style={{ color: "red" }}>*</span>
                    </Box>

                    <FormControl
                      sx={{ width: "300px", pr: 1, mt: 3 }}
                      size="small"
                    >
                      {/* <InputLabel>Select Location</InputLabel> */}
                      <Select
                        sx={{
                          textAlign: "left",
                          fontSize: "14px",
                          "& .MuiSelect-multiple": {
                            fontSize: "14px",
                          },
                        }}
                        value={selectedLocationTypes}
                        onChange={handleLocationChange}
                        // input={<OutlinedInput label='Select Year' />}
                      >
                        {locationTypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{ fontSize: "12px", marginLeft: "1px" }}
                      >
                        Please select where the meeting was held.
                      </FormHelperText>
                    </FormControl>
                  </Box>
                  <Box>
                    <Box
                      sx={{
                        fontSize: "14px",
                        margin: "8px 0px -10px 0px",
                        textAlign: "left",
                      }}
                    >
                      Location<span style={{ color: "red" }}>*</span>
                    </Box>
                    <TextField
                      multiline
                      // label="Type here.."
                      variant="outlined"
                      value={locationdesc}
                      rows={3}
                      onChange={handleLocationdescChange}
                      helperText={`${locationcharCount}/150 characters. Enter upto 150 characters. Please add the exact address of the meeting, if done face-to-face.`}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "700px",
                        "& .MuiInputBase-inputMultiline": {
                          fontSize: "14px",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                    {/* <FormHelperText sx={{fontSize:"12px",marginLeft:"-0.5px"}}>Enter upto 255 characters. Please add the exact address of the meeting, if done face-to-face. </FormHelperText> */}
                  </Box>
                </Stack>
              </Box>
            {/* )} */}
            <Paper sx={styles.papercss}>Requirement</Paper>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                // width: "100%",
              }}
            >
              <Box
                sx={{
                  fontSize: "14px",
                  margin: "8px 0px -10px 0px",
                }}
              >
                Lead Requirement<span style={{ color: "red" }}>*</span>
              </Box>
              <TextField
                multiline
                // label="Type here.."
                variant="outlined"
                value={reqdesc}
                rows={3}
                onChange={handleRequirementChange}
                helperText={`${reqcharCount}/150 characters. Enter upto 150 characters. Briefly explain the client expectation.`}
                inputProps={{ maxLength: 150 }}
                fullWidth
                // sx={{ mt: 2,width:"1115px" }}
                sx={{
                  mt: 2,
                  width: "1115px",
                  "& .MuiInputBase-inputMultiline": {
                    fontSize: "14px",
                  },
                  "& .MuiFormHelperText-root": {
                    textAlign: "left",
                    marginLeft: "-1px",
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "700px" }}>
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
                sx={{
                  width: "100%",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ flex: "1 1 auto", minWidth: "300px" }}>
                  <Box>
                    <Box
                      sx={{
                        fontSize: "14px",
                        margin: "12px 0px 5px 0px",
                        textAlign: "left",
                      }}
                    >
                      Wealth Product Discussed
                    </Box>

                    <FormControl sx={{ width: "100%" }} size="small">
                      <Select
                        sx={{
                          textAlign: "left",
                          fontSize: "14px",
                          "& .MuiSelect-multiple": {
                            fontSize: "14px",
                          },
                        }}
                        labelId={`techniques-label`}
                        id="demo-multiple-checkbox-techniques"
                        multiple
                        value={selectedwealthproduct}
                        onChange={(e) =>
                          setselectedwealthproduct(e.target.value)
                        }
                        input={<OutlinedInput />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                      >
                        {wealthproductTypes.map((name) => (
                          <MenuItem key={name.id} value={name.masterValueDesc}>
                            <Checkbox
                              checked={
                                selectedwealthproduct.indexOf(
                                  name.masterValueDesc
                                ) > -1
                              }
                            />
                            <ListItemText primary={name.masterValueDesc} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormHelperText sx={{ fontSize: "12px" }}>
                      Select all that was discussed or can be proposed.
                    </FormHelperText>
                  </Box>
                </Box>
                <Box sx={{ flex: "1 1 auto", minWidth: "300px" }}>
                  <Box>
                    <Box
                      sx={{
                        fontSize: "14px",
                        margin: "12px 0px 5px 0px",
                        textAlign: "left",
                      }}
                    >
                      Other Business Opportunity
                    </Box>

                    <FormControl sx={{ width: "100%" }} size="small">
                      <Select
                        sx={{
                          textAlign: "left",
                          fontSize: "14px",
                          "& .MuiSelect-multiple": {
                            fontSize: "14px",
                          },
                        }}
                        labelId={`techniques-label`}
                        id="demo-multiple-checkbox-techniques"
                        multiple
                        value={selectedotherbusinesstype}
                        onChange={(e) =>
                          setSelectedotherbusinesstype(e.target.value)
                        }
                        input={<OutlinedInput />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                      >
                        {otherBusinessTypes.map((name) => (
                          <MenuItem key={name.id} value={name.masterValueDesc}>
                            <Checkbox
                              checked={
                                selectedotherbusinesstype.indexOf(
                                  name.masterValueDesc
                                ) > -1
                              }
                            />
                            <ListItemText primary={name.masterValueDesc} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormHelperText sx={{ fontSize: "12px" }}>
                      Select all that was discussed or can be proposed.
                    </FormHelperText>
                  </Box>
                </Box>
                <Box sx={{ flex: "1 1 auto", minWidth: "300px" }}>
                  <Box
                    sx={{
                      fontSize: "14px",
                      margin: "12px 0px 5px 0px",
                      textAlign: "left",
                    }}
                  >
                    Estimated Annual Income
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                    <FormControl sx={{ width: "100%" }} size="small">
                      <Select
                        sx={{
                          textAlign: "left",
                          fontSize: "14px",
                          "& .MuiSelect-multiple": {
                            fontSize: "14px",
                          },
                        }}
                        value={selectedannualincometypes}
                        onChange={handleAnnualIncomeChange}
                      >
                        {annualincometypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{
                          fontSize: "12px",
                          textAlign: "left",
                          marginLeft: "0px",
                          maxWidth: "100%",
                          display: "block",
                        }}
                      >
                        Select what according to you would be the client's
                        estimated Income.
                      </FormHelperText>
                    </FormControl>
                    {selectedannualincometypes && (
                      <Tooltip title="Clear">
                        <IconButton
                          onClick={() => setselectedannualincometypes("")}
                          aria-label="clear selection"
                          size="small"
                          sx={{ ml: 1, mt: 1 }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </Box>
              </Stack>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                // width: "100%",
              }}
            >
              <Box sx={{ fontSize: "14px", margin: "8px 0px -10px 0px" }}>
                Other Advisor
              </Box>
              <TextField
                multiline
                // label="Type here.."
                variant="outlined"
                value={reqotheradvisor}
                rows={3}
                onChange={handleRequirementChangeother}
                helperText={`${reqothercount}/150 characters. Enter upto 150 characters. Briefly explain other advisor details.`}
                inputProps={{ maxLength: 150 }}
                fullWidth
                // sx={{ mt: 2,width:"1115px" }}
                sx={{
                  mt: 2,
                  width: "1115px",
                  "& .MuiInputBase-inputMultiline": {
                    fontSize: "14px",
                  },
                  "& .MuiFormHelperText-root": {
                    textAlign: "left",
                    marginLeft: "-1px",
                  },
                }}
              />
            </Box>
            {/* <Box sx={{ marginTop: "12px" }}></Box> */}

            <Paper sx={styles.papercss}>Status</Paper>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Box>
                <Box>
                  <Box
                    sx={{
                      fontSize: "14px",
                      margin: "12px 0px -10px 0px",
                      textAlign: "left",
                    }}
                  >
                    Status<span style={{ color: "red" }}>*</span>
                  </Box>

                  <FormControl
                    sx={{ width: "300px", pr: 1, mt: 2 }}
                    size="small"
                  >
                    {/* <InputLabel>Select Status</InputLabel> */}
                    <Select
                      sx={{
                        textAlign: "left",
                        fontSize: "14px",
                        "& .MuiSelect-multiple": {
                          fontSize: "14px",
                        },
                      }}
                      value={selectedStatustype}
                      onChange={handleStatusChange}
                      // input={<OutlinedInput label='Select Year' />}
                    >
                      {statustypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.masterValueDesc}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      sx={{ fontSize: "12px", marginLeft: "1px" }}
                    >
                      Please select according to you what is the client status
                      after the meeting.
                    </FormHelperText>
                  </FormControl>
                </Box>
              </Box>
              {selectedStatustype !== 24 && selectedStatustype !== 25 && (
                <Box>
                  <Box>
                    <Box
                      sx={{
                        fontSize: "14px",
                        margin: "12px 0px -10px 0px",
                        textAlign: "left",
                      }}
                    >
                      Lead Status<span style={{ color: "red" }}>*</span>
                    </Box>

                    <FormControl
                      sx={{ width: "300px", pr: 1, mt: 2 }}
                      size="small"
                    >
                      {/* <InputLabel>Select Lead Status</InputLabel> */}
                      <Select
                        sx={{
                          textAlign: "left",
                          fontSize: "14px",
                          "& .MuiSelect-multiple": {
                            fontSize: "14px",
                          },
                        }}
                        value={selectedleadstatustype}
                        onChange={handleLeadStatusChange}
                        // input={<OutlinedInput label='Select Year' />}
                      >
                        {leadstatustypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                      >
                        Select based on your understanding the probability of
                        onboarding the client.
                      </FormHelperText>
                    </FormControl>
                  </Box>
                </Box>
              )}
            </Stack>
            {selectedStatustype !== 25 ? (
              <Box>
                <Paper sx={styles.papercss}>Estimation</Paper>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                >
                  {selectedStatustype === 24 ? (
                    <Stack
                      direction="row"
                      divider={<Divider orientation="vertical" flexItem />}
                      spacing={2}
                    >
                      <Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            margin: "12px 0px 0px 0px",
                            textAlign: "left",
                          }}
                        >
                          Closed Date
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            sx={{
                              paddingTop: "5px",
                            }}
                            components={["DatePicker"]}
                          >
                            <DatePicker
                              value={expectedDateClosure}
                              onChange={handleexpectedDateChange}
                              disableFuture // Ensure current or past dates
                              format="DD/MM/YYYY" // Customize the format here
                              slotProps={{
                                // paddingTop: "5px",
                                textField: {
                                  size: "small",
                                },
                              }}
                            />
                          </DemoContainer>
                          <FormHelperText sx={{ fontSize: "12px" }}>
                            Select the date when the client was onboarded.
                          </FormHelperText>
                        </LocalizationProvider>
                      </Box>
                      <Box sx={{ width: "300px" }}>
                        <Box
                          sx={{
                            fontSize: "14px",
                            margin: "12px 0px 5px 0px",
                            textAlign: "left",
                          }}
                        >
                          Actual Portfolio Value
                        </Box>
                        <TextField
                          size="small"
                          // type="number"
                          fullWidth
                          sx={{
                            textAlign: "left",
                            fontSize: "14px",
                            "& .MuiInputBase-input": {
                              fontSize: "14px",
                            },
                          }}
                          value={actualPortfolioValue}
                          onChange={handleActualPortfolioChange}
                          // InputProps={{
                          //   inputProps: { min: 0 },
                          // }}
                        />
                        <FormHelperText
                          sx={{
                            fontSize: "12px",
                            textAlign: "left",
                            marginLeft: "0px",
                            maxWidth: "100%",
                            display: "block",
                          }}
                        >
                          Enter the client's actual portfolio value.
                        </FormHelperText>
                      </Box>
                    </Stack>
                  ) : (
                    <Stack
                      direction="row"
                      divider={<Divider orientation="vertical" flexItem />}
                      spacing={2}
                    >
                      <Box sx={{ width: "300px" }}>
                        <Box
                          sx={{
                            fontSize: "14px",
                            margin: "12px 0px 0px 0px",
                            textAlign: "left",
                          }}
                        >
                          Expected Date of Closure
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            sx={{
                              paddingTop: "5px",
                            }}
                            components={["DatePicker"]}
                          >
                            <DatePicker
                              value={expectedDateClosure}
                              onChange={handleexpectedDateChange}
                              format="DD/MM/YYYY" // Customize the format here
                              disablePast // Ensure future dates
                              slotProps={{
                                // paddingTop: "5px",
                                textField: {
                                  size: "small",
                                },
                              }}
                            />
                          </DemoContainer>
                          <FormHelperText sx={{ fontSize: "12px" }}>
                            Select what according to you would be the client
                            onboarding date.
                          </FormHelperText>
                        </LocalizationProvider>
                      </Box>
                      <Box sx={{ width: "300px" }}>
                        <Box
                          sx={{
                            fontSize: "14px",
                            margin: "12px 0px 5px 0px",
                            textAlign: "left",
                          }}
                        >
                          Estimated Portfolio Value
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                          <FormControl sx={{ width: "100%" }} size="small">
                            <Select
                              sx={{
                                textAlign: "left",
                                fontSize: "14px",
                                "& .MuiSelect-multiple": {
                                  fontSize: "14px",
                                },
                              }}
                              value={selectedPortfolioRange}
                              onChange={handlePortfolioRangeChange}
                            >
                              {annualincometypes.map((type) => (
                                <MenuItem key={type.id} value={type.id}>
                                  {type.masterValueDesc}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText
                              sx={{
                                fontSize: "12px",
                                textAlign: "left",
                                marginLeft: "0px",
                                maxWidth: "100%",
                                display: "block",
                              }}
                            >
                              Select what according to you would be the client's
                              estimated Portfolio Value.
                            </FormHelperText>
                          </FormControl>
                          {selectedPortfolioRange && (
                            <Tooltip title="Clear">
                              <IconButton
                                onClick={() => setSelectedPortfolioRange("")}
                                aria-label="clear selection"
                                size="small"
                                sx={{ ml: 1, mt: 1 }}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                    </Stack>
                  )}
                </Stack>
                {selectedStatustype === 24 ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      // width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: "14px",
                        margin: "8px 0px -10px 0px",
                        textAlign: "left",
                      }}
                    >
                      Portfolio Description
                    </Box>
                    <TextField
                      multiline
                      variant="outlined"
                      value={portfoliodesc}
                      rows={3}
                      onChange={handlePortfolioChange}
                      helperText={`${portfolioCount}/150 characters. Enter up to 150 characters. Please share Asset wise portfolio details.`}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "1115px",
                        "& .MuiInputBase-inputMultiline": {
                          fontSize: "14px",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      // width: "100%",
                    }}
                  >
                    <Box sx={{ fontSize: "14px", margin: "8px 0px -10px 0px" }}>
                      Estimated Portfolio Description
                    </Box>
                    <TextField
                      multiline
                      variant="outlined"
                      value={portfoliodesc}
                      rows={3}
                      onChange={handlePortfolioChange}
                      helperText={`${portfolioCount}/150 characters. Enter up to 150 characters. Please share Asset wise portfolio details.`}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "1115px",
                        "& .MuiInputBase-inputMultiline": {
                          fontSize: "14px",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                  </Box>
                )}
              </Box>
            ) : null}

            {/* <FormHelperText sx={{fontSize:"12px"}}>Enter upto 1024 characters. Please share Asset wise portfolio details. */}

            {/* </FormHelperText> */}
            {selectedStatustype !== 24 && selectedStatustype !== 25 && (
              <Box>
                <Paper sx={styles.papercss}>Follow Up Details</Paper>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                >
                  <Box>
                    <Box
                      sx={{
                        fontSize: "15px",
                        margin: "12px 0px -10px 0px",
                        textAlign: "left",
                      }}
                    >
                      Follow Up Mode
                    </Box>
                    <FormControl
                      sx={{ width: "300px", pr: 1, mt: 3 }}
                      size="small"
                    >
                      <Select
                        sx={{
                          textAlign: "left",
                          fontSize: "14px",
                          "& .MuiSelect-multiple": {
                            fontSize: "14px",
                          },
                        }}
                        value={selectedfollowuptype}
                        onChange={handlefollowupChange}
                      >
                        {followuptypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                      >
                        Please select what would be the mode of the followup.{" "}
                      </FormHelperText>
                    </FormControl>
                  </Box>
                  <Box sx={{ width: "300px" }}>
                    <Box
                      sx={{
                        fontSize: "15px",
                        margin: "15px 0px -10px 0px",
                        textAlign: "left",
                      }}
                    >
                      Follow Up Date & Time
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        sx={{ marginTop: "12px" }}
                        components={["DateTimePicker"]}
                      >
                        <DateTimePicker
                          value={meetingDateTime}
                          onChange={handleDateTimeChange}
                          format="DD/MM/YYYY hh:mm A" // Customize the format here
                          slotProps={{
                            // paddingTop: "5px",
                            textField: {
                              size: "small",
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Box>
                  {selectedfollowuptype === 36 && (
                    <Box>
                      <Box
                        sx={{
                          fontSize: "15px",
                          margin: "12px 0px -10px 0px",
                          textAlign: "left",
                        }}
                      >
                        Follow Up Location Type
                      </Box>
                      <FormControl
                        sx={{ width: "300px", pr: 1, mt: 3 }}
                        size="small"
                      >
                        <Select
                          sx={{
                            textAlign: "left",
                            fontSize: "14px",
                            "& .MuiSelect-multiple": {
                              fontSize: "14px",
                            },
                          }}
                          value={selectedfollowuplocationtype}
                          onChange={handlefollowuplocationChange}
                        >
                          {followuplocationtypes.map((type) => (
                            <MenuItem key={type.id} value={type.id}>
                              {type.masterValueDesc}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          sx={{ fontSize: "12px", marginLeft: "-1px" }}
                        >
                          Please select where the followup meeting will be held.
                        </FormHelperText>
                      </FormControl>
                    </Box>
                  )}
                </Stack>
                {selectedfollowuptype === 36 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      // width: "100%",
                    }}
                  >
                    <Box sx={{ fontSize: "14px", margin: "8px 0px -10px 0px" }}>
                      Location
                    </Box>
                    <TextField
                      multiline
                      variant="outlined"
                      value={followupdesc}
                      rows={3}
                      onChange={handlefollowChange}
                      helperText={`${followupcharcount}/150 characters. Enter up to 150 characters. Please add the exact address of the meeting, if done face-to-face.`}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "1115px",
                        "& .MuiInputBase-inputMultiline": {
                          fontSize: "14px",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                  </Box>
                )}
              </Box>
            )}

            <Paper sx={styles.papercss}>Additional Information</Paper>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                // width: "100%",
              }}
            >
              <Box sx={{ fontSize: "14px", margin: "8px 0px -10px 0px" }}>
                Additional Comments
              </Box>
              <TextField
                multiline
                // label="Type here.."
                variant="outlined"
                value={additionalcomment}
                rows={3}
                onChange={handleadditionalcommentChange}
                helperText={`${additionalcommentcharcount}/150 characters.Enter upto 150 characters. Enter additional information if needed.`}
                inputProps={{ maxLength: 150 }}
                fullWidth
                sx={{
                  mt: 2,
                  width: "1115px",
                  "& .MuiInputBase-inputMultiline": {
                    fontSize: "14px",
                  },
                  "& .MuiFormHelperText-root": {
                    textAlign: "left",
                    marginLeft: "-1px",
                  },
                }}
              />
              {/* <FormHelperText sx={{fontSize:"12px"}}>Enter upto 255 characters. Please add the exact address of the meeting, if done face-to-face. </FormHelperText> */}
            </Box>

            <Box
              sx={{
                display: "flex ",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Button
                onClick={cancelHandler}
                variant="outlined"
                sx={{
                  color: "Black",
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  padding: "5px 15px",
                  background: "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  textTransform: "none",
                  backgroundColor:
                    !discussionBrief ||
                    !selectedEngagementType ||
                    !meetingDate ||
                    // !selectedmeetingduration ||
                    !reqdesc ||
                    !selectedLocationTypes ||
                    !locationdesc ||
                    !selectedStatustype
                      ? // !selectedleadstatustype
                        "#ccc"
                      : "#002C51", // Different background color when disabled
                  "&:hover": {
                    backgroundColor:
                      !discussionBrief ||
                      !selectedEngagementType ||
                      !meetingDate ||
                      // !selectedmeetingduration ||
                      !reqdesc ||
                      !selectedLocationTypes ||
                      !locationdesc ||
                      !selectedStatustype
                        ? // !selectedleadstatustype
                          "#ccc"
                        : "#003D6B", // Adjust hover color when disabled
                  },
                }}
                disabled={
                  !discussionBrief ||
                  !selectedEngagementType ||
                  !meetingDate ||
                  // !selectedmeetingduration ||
                  !reqdesc ||
                  !selectedStatustype ||
                  !selectedLocationTypes ||
                  !locationdesc
                }
              >
                Save
              </Button>
            </Box>
          </form>
        </div>
      </Paper>
    </Box>
  );
};

export default NewClientInteraction;
const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};
const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // height: "90vh",
    minHeight: "100px",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btn: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "340px",
  },
  papercss: {
    heignt: "250px",
    // width: "100%",
    color: "white",
    fontSize: "17px",
    fontWeight: "bold",
    // border:"1px solid red",
    padding: "12px",
    marginBottom: "12px",
    marginTop: "14px",
    backgroundColor: "#223d6c",
    textAlign: "left",
  },
};
const style = {
  position: "absolute",
  top: "54%",
  left: "50%",
  right: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  height: 600,
  overflow: "auto",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "2px",

  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "#d9d9d9 #fff", // For Firefox
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d9d9d9",
  },
};
